// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1772":"css/admin-app.6976","6330":"css/app.6976"}[chunkId] + ".css";
};